import { Box } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { muiPalette } from '@/shared/general-theme';

import { Header } from './components';

const Layout: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        bgcolor: muiPalette.background.default,
      }}
    >
      <Header />

      <Box
        component="main"
        sx={{
          flex: 1,
          overflowY: 'auto',
          p: { xs: 2, md: 4 }
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;